module.exports = __webpack_public_path__ + "static/chart_of_accounts-b11af8e7c9202872b244cef2e58801ac.png";